module.exports = "/images/lt.svg";